module.exports = __webpack_public_path__ + "img/Back Window.5333feaf.png";